
  export const typeOptions = [
    { value: 'Company', label: 'Company', 'data-testid': 'participant-type-company' },
    { value: 'Landowner', label: 'Landowner', 'data-testid': 'participant-type-landowner' },
    { value: 'Indigenous Community', label: 'Indigenous Community', 'data-testid': 'participant-type-indigenous-community' },
    { value: 'Municipality', label: 'Municipality', 'data-testid': 'participant-type-municipality' },
    { value: 'Environmental Group', label: 'Environmental Group', 'data-testid': 'participant-type-environmental-group' },
    { value: 'AER', label: 'AER', 'data-testid': 'participant-type-aer' },
    { value: 'Other', label: 'Other', 'data-testid': 'participant-type-other' },
  ];  